module.exports = __webpack_public_path__ + "img/caruaru_hero_card.891cf758.png";